<script lang="ts">
    import { createEventDispatcher } from "svelte";

    export let monthName: string;
	export let monthNumber: number;
	export let yearNumber: number;

    const dispatch = createEventDispatcher();

    const backMonth = () => {
        monthNumber -= 1
        dispatch('backMonth', {
            monthNumber: monthNumber
        })
    }

    const forwardMonth = () => {
        monthNumber += 1
        dispatch('forwardMonth', {
            monthNumber: monthNumber
        })
    }

</script>
<div class="grid grid-cols-4 p-1 mb-3">
    <div class="flex p-1 justify-center cursor-pointer" on:click="{backMonth}">&lt;&lt;</div>
    <div class="flex p-1 justify-center font-bold">{monthName}</div>
    <div class="flex p-1 justify-center font-bold">{yearNumber}</div>
    <div class="flex p-1 justify-center cursor-pointer" on:click="{forwardMonth}">&gt;&gt;</div>
</div>